import React, { useState, useEffect, useContext } from "react"
import { useParams } from "react-router-dom"
import { SurveyHeader } from "./controllers/SurveyHeader.controller"
import { SurveyBody } from "./controllers/SurveyBody.controller"
import {
  getSurveyData,
  createClientSurvey,
} from "../../services/survey.service"
import { ThemeContext } from "../../contexts/ThemeContext.context"
import { View404 } from "../systemPages/View404.view"

export function Survey() {
  const { token } = useParams()
  const [surveyData, setSurveyData] = useState(null)
  const [answers, setAnswers] = useState({})
  const { changeTheme } = useContext(ThemeContext)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [error404, setError404] = useState(false)

  useEffect(() => {
    changeTheme("light")
  }, [changeTheme])

  useEffect(() => {
    let cancelled = false

    const fetchSurveyData = async () => {
      if (!token) {
        if (!cancelled) setError404(true)
        return
      }

      try {
        const decryptedResponse = await getSurveyData(token)

        if (cancelled) return

        if (decryptedResponse.status === 404) {
          setError404(true)
          return
        }

        if (!decryptedResponse.success) {
          setError404(true)
          return
        }

        const data = decryptedResponse.result

        setSurveyData({
          client: data.client,
          survey: data.survey,
        })
      } catch (error) {
        if (!cancelled) {
          setError404(true)
        }
      }
    }

    fetchSurveyData()

    return () => {
      cancelled = true
    }
  }, [token])

  if (error404) {
    return <View404 />
  }

  if (!surveyData) {
    return <div>Cargando encuesta...</div>
  }

  const { client, survey } = surveyData

  const updateAnswer = (questionId, field, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: {
        ...prev[questionId],
        [field]: value,
      },
    }))
  }

  const handleSubmit = async (payload) => {
    const surveyPayload = {
      ...payload,
      clientId: client.clientId,
    }

    const response = await createClientSurvey(surveyPayload)

    if (response.success) {
      setIsSubmitted(true)
    } else {
      console.error("Error al guardar:", response.message)
    }
  }

  return (
    <div
      id="survey-page"
      className="flex flex-column gap-3  pb-6 survey-container"
    >
      <SurveyHeader client={client} survey={survey} />
      <div
        className={`flex justify-center ${isSubmitted ? "survey-success-container" : ""}`}
      >
        <div className="survey-main-container  ">
          <SurveyBody
            survey={survey}
            answers={answers}
            updateAnswer={updateAnswer}
            onSubmit={handleSubmit}
            isSubmitted={isSubmitted}
          />
        </div>
      </div>
    </div>
  )
}
